module.exports = __webpack_public_path__ + "img/i_o_my_chat.5d30d6e1.svg";